import FootPrintData from 'Components/Footprint/Interfaces/FootPrintData';

const FootPrintState: FootPrintData = {
	companyId:'',
    locations:[],
    emissionsData:{}
};

export default FootPrintState;